












































import { Vue, Component, Prop } from 'vue-property-decorator'
import { Ms, Bp } from '@/types/hd'
import LineChart from '@/components/hdTab/LineChart.vue'
import dayjs from 'dayjs'

const TIME_SPAN = 30

@Component({
  components: {
    LineChart
  }
})
export default class HdChart extends Vue {
  @Prop({ default: 0 }) dialysisTime!: number
  @Prop({ default: '' }) startDatetime!: string
  @Prop({ default: '' }) endDatetime!: string
  @Prop({ default: () => [] }) msList!: Ms[]
  @Prop({ default: () => [] }) bpList!: Bp[]

  option = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [
        {
          type: 'time',
          time: {
            distribution: 'linear',
            tooltipFormat: 'HH:mm',
            displayFormats: {
              minute: 'HH:mm'
            }
          },
          ticks: {
            source: 'labels'
          }
        }
      ]
    }
  }

  styles = {
    height: '300px',
    position: 'relative'
  }

  graphTableItems = [
    {
      displayName: '総除水量(l)',
      key: 'waterRemoval'
    },
    {
      displayName: '除水速度(l/h)',
      key: 'ultrafiltrationRate'
    },
    {
      displayName: '血流量(ml/min)',
      key: 'bloodFlow'
    },
    {
      displayName: '静脈圧(mmHg)',
      key: 'venousPressure'
    },
    {
      displayName: '透析液圧(mmHg)',
      key: 'dialysatePressure'
    },
    {
      displayName: '抗凝固剤積算量(ml)',
      key: 'anticoagulantAmountTotal'
    },
    {
      displayName: '補液量(l)',
      key: 'substitutionFluidAmount'
    }
  ]

  get chartData() {
    const { bpDataset } = this
    return {
      labels: this.timeLabels,
      datasets: [
        {
          label: '血圧上',
          data: bpDataset.sbp,
          borderColor: 'rgba(213,91,38, 0.5)',
          lineTension: 0,
          fill: false
        },
        {
          label: '血圧下',
          data: bpDataset.dbp,
          borderColor: 'rgba(151,193,92,0.5)',
          lineTension: 0,
          fill: false
        },
        {
          label: '脈拍',
          data: bpDataset.pulse,
          borderColor: 'rgba(71,150,236, 0.5)',
          lineTension: 0,
          fill: false
        }
      ]
    }
  }

  get bpDataset() {
    return {
      sbp: this.bpList.map(bp => ({
        x: dayjs(bp.measureDatetime).toDate(),
        y: bp.sbp
      })),
      dbp: this.bpList.map(bp => ({
        x: dayjs(bp.measureDatetime).toDate(),
        y: bp.dbp
      })),
      pulse: this.bpList.map(bp => ({
        x: dayjs(bp.measureDatetime).toDate(),
        y: bp.pulse
      }))
    }
  }

  get timeLabels() {
    const labels = []
    // グラフに表示する時間に1時間分のバッファをもうける
    const labelNum = Math.ceil(this.dialysisTime / TIME_SPAN) + 3
    for (let i = 0; i < labelNum; i++) {
      const time = dayjs(this.startDatetime)
        .add(30 * i, 'm')
        .toDate()
      labels.push(time)
    }
    return labels
  }

  getMsValue({ type, endTime }: { type: string; endTime: Date }) {
    const timespan = {
      start: dayjs(endTime).subtract(30, 'm'),
      end: dayjs(endTime)
    }
    let value = null
    const isLastSpan =
      timespan.start.subtract(30, 'm') < dayjs(this.endDatetime) &&
      timespan.end.subtract(30, 'm') >= dayjs(this.endDatetime)
    if (isLastSpan) {
      const last = this.msList.slice().pop()
      value = last ? last[type as keyof Ms] : null
    } else {
      const latest = this.msList.slice().find(ms => {
        const time = dayjs(ms.dialysisDatetime)
        return (
          //30分区切りの時間内の先頭 or 末尾（終了時）のデータを選び出す
          //startTime <= time < endTime
          (time.isAfter(timespan.start) && time.isBefore(timespan.end)) ||
          time.isSame(timespan.start)
        )
      })
      value = latest ? latest[type as keyof Ms] : null
    }

    if (typeof value === 'number') {
      if (
        ['anticoagulantAmountTotal', 'substitutionFluidAmount'].includes(type)
      ) {
        value = value.toFixed(1)
      } else if (['waterRemoval', 'ultrafiltrationRate'].includes(type)) {
        value = value.toFixed(2)
      }
    }

    if (isLastSpan && value != null) {
      value = `(${value})`
    }
    return value
  }
}
